import styled from "styled-components";

export const Container = styled.div`
  .productList {
    margin-top: 15px;
    display: flex;
    overflow: scroll;
    gap: 6px;
  }

  @media (min-width: 1100px) {
    .productList {
      overflow: hidden;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: flex-start;
    }
  }
`;
